import { Card, Center, Title } from '@mantine/core';
import classes from './TopBanner.module.css';
import { useTranslation } from 'react-i18next';

export const TopBanner = (props) => {

    const { t } = useTranslation();

    const {
        title = null
    } = props;

    return (

            <Title className={classes.mainTitle}>{ title ?? t('templates.bannerTitle') }</Title>
 
    )
}